'use strict';

var processInclude = require('./util');

$(document).ready(function () {
    processInclude(require('./product/detail'));
    processInclude(require('./product/quickView'));

    if ( $('.page').data('action') === 'Product-Show') {
        pushDataAnalytics();
    }
});


function pushDataAnalytics() {
    let container = $('.analytics.product');
    if (container.length === 0) {
        // We are not in PDP
        return;
    }

    var prodPid = container.data('id');
    var prodName = container.data('name');
    var prodPrice = container.data('price');
    var prodBrand = container.data('brand');
    var prodColor = container.data('variant');
    var prodCategory = container.data('category');
    var prodCurrency = container.data('currency');
    var item = {
        name: prodName ? prodName : '',
        id: prodPid ? prodPid : '',
        price: prodPrice ? prodPrice : '',
        brand: prodBrand ? prodBrand : '',
        category: prodCategory ? prodCategory : '',
        variant: prodColor ? prodColor : ''
    }

    let pushObject = {
        'event': 'productDetail',
        'ecommerce': {
        'currencyCode': prodCurrency,
        'detail': {
                'products': [item]
            }
        }
    };

    dataLayer.push(pushObject);

    // 2024 tracking dataLayer - start
    var isvariant = container.data('isvariant');
    if(isvariant) {
        let trackingItem =  {
            item_id: prodPid ? prodPid : '',
            item_name: prodName ? prodName : '',
            price: prodPrice ? prodPrice : 0,
            item_brand: prodBrand ? prodBrand : '',
            item_category: prodCategory ? prodCategory : ''
        };
        var trackingItems = [];
        trackingItems.push(trackingItem);

        let trackingData = {
            'event': 'view_item',
            'currency': prodCurrency,
            'value': trackingItem.price,
            'items': trackingItems
        };

        window.dataLayer.push(trackingData);
    }
    // 2024 tracking dataLayer - end
}


// WEBPACK FOOTER //
// ./cartridges/app_fh/cartridge/client/default/js/productDetail.js